import React, { useState, useEffect } from "react";
import { Link } from "gatsby";

function RecentCaseStudies({ data }) {
  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();
    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    }, []);
    return variant;
  };
  // const variant = 1;
  const variant = useExperiment("_b1eORemTP6uefA63zaTlQ");

  return (
    <>
      <div className="bg-[#000000] text-white w-full mx-auto font-primary font-light p-6 listed">
        <div className="py-3 w-9/12 mx-auto">
          <h3 className="text-lightBlue text-24 mb-5 font-primary">
            Related Case Studies
          </h3>
          <ul>
            {data?.recent_news.map(({ slug, label }, i) => (
              <li key={i}>
                <Link
                  className="text-new py-2  hover:text-lightBlue cursor-pointer"
                  to={slug}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div class="bg-[#000000] text-white w-full mx-auto font-primary font-light flex justify-center items-center  flex-wrap lg:flex-nowrap lg:flex-row flex-col">
        <div className="flex flex-col mx-20 py-5">
          <p style="color:#fff;font-size:21px;">Ready to get started?</p>
          <span
            class="random1 green-btn"
            style="border-radius: 40px;margin-top: 30px;background-color: rgb(127, 205, 23) !important;padding: 10px;text-align: center;"
          >
            <Link
              hreflang="en-us"
              to="/quote"
              class="tomedes-button green-btn-hvr"
            >
              {variant == "1" ? "START TRANSLATION" : "Translate Now"}
            </Link>
          </span>
        </div>
        <div className="flex flex-col mx-20 py-5">
          <p style="color:#fff;font-size:21px;">
            Want to tell us more about your needs?
          </p>
          <span
            class="random black"
            style="background: none;border-radius: 40px;border: 1px solid rgb(255, 255, 255);display: block;width: 150px;text-align: center;margin: auto;margin-top: 30px;padding: 12px 10px;"
          >
            <Link hreflang="en-us" to="/contactus.php" class="tomedes-button">
              Contact Us
            </Link>
          </span>
        </div>
      </div>
    </>
  );
}
export default RecentCaseStudies;
